import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './api';

export interface PricingTier {
  public_price_monthly: number | null;
  public_price_yearly: number | null;
  session_limit: number | null;
}

export interface PricingResponse {
  country_code: string;
  currency: string | null;
  tiers: {
    accessible: PricingTier;
    standard: PricingTier;
    premium: PricingTier;
  };
}

export function usePricing(countryCode: string | undefined) {
  return useQuery({
    queryKey: ['pricing', countryCode],
    queryFn: () => apiFetch<PricingResponse>(`/pricing/${countryCode}`),
    enabled: !!countryCode,
  });
}
